export default "__VITE_ASSET__CQAX1gRE__"